<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :height="height"
      :loading="loading"
      :data="data"
      :columns="tableColumns"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :row-class-name="
        ({ row }) => [
          row.success ? '' : 'error-row',
          row.warning ? 'warning-row' : '',
        ]
      "
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #displayImportMsg="{ row }">
        <div
          v-if="row.errorMsgs && row.errorMsgs.length"
          :class="{ 'mb-2': row.warningMsgs && row.warningMsgs.length }"
          style="color: #f56c6c;"
        >
          <div
            v-for="(errorMsg, index) in row.errorMsgs"
            :key="index"
            :class="{ 'mt-1': index }"
          >
            <span class="mr-1">{{ index + 1 }}.</span>
            <span>{{ errorMsg }}</span>
          </div>
        </div>

        <div
          v-if="row.warningMsgs && row.warningMsgs.length"
          style="color: #e6a23c;"
        >
          <div
            v-for="(warningMsg, index) in row.warningMsgs"
            :key="index"
            :class="{ 'mt-1': index }"
          >
            <span class="mr-1">{{ index + 1 }}.</span>
            <span>{{ warningMsg }}</span>
          </div>
        </div>
      </template>

      <template #displayReportPerson="{ row }">
        <div v-if="row.displayUserNames && row.displayUserNames.length">
          <div
            v-for="(displayUserName, index) in row.displayUserNames"
            :key="index"
          >
            <span>{{ displayUserName }}</span>
          </div>
        </div>
      </template>

      <template #empty>
        <div>{{ $l('INDEX.table_label_no_data') || '暂无数据！' }}</div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  computed: {
    height() {
      const h = this.tableHeight - 50
      return h <= 400 ? 400 : h
    },
    data() {
      if (!this.tableData?.length) return []

      return this.tableData.map((item) => {
        const userList = item.userList || []
        return {
          ...item,
          displayUserNames: userList.map((user) => {
            const { userNo, userName } = user
            return userNo ? `${userName}（${userNo}）` : userName
          }),
        }
      })
    },
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
// ::v-deep {
//   .vxe-grid {
//     .vxe-body--row.error-row {
//       background-color: #f56c6c !important;
//       .vxe-body--column .vxe-cell {
//         color: white;
//       }
//     }
//     .vxe-body--row.warning-row {
//       background-color: #e6a23c !important;
//       color: white;
//     }
//   }
// }
</style>
